import { get, pick } from 'lodash';
import gtm from '@/lib/gtm';
import { mapGetters } from 'vuex';
import { DetectHTMLTagsPattern } from '@/lib/utils';
import { UPDATE_JOBS, STATISTICS_JOB_VIEW } from '@/lib/api.js';

import JobDetails from '@/components/Jobs_List/Job_Details/JobDetails';
import ShareJob from '@/components/Jobs_List/Share_Job/ShareJob';
import AddToFavorite from '@/components/Jobs_List/Add_To_Favorite/AddToFavorite';
import CategoriesFooter from '@/components/Jobs_List/CategoriesFooter/CategoriesFooter';
import JobFooter from '@/components/Jobs_List/Job_Footer/JobFooter';
import CvButton from '@/components/Jobs_List/Cv_Button/CvButton';
import JobScopes from '@/components/Jobs_List/Job_Scopes/JobScopes';

const JobHeader = {
  components: {
    JobFooter,
    JobDetails,
    CategoriesFooter,
    AddToFavorite,
    ShareJob,
    CvButton,
    JobScopes
  },

  props: {
    isHitech: {
      type: Boolean,
      required: false,
      default: false
    },
    ssasource: {
      type: Number,
      required: false,
      default: 0
    },
    isAA: {
      type: Boolean,
      required: false,
      default: false
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0
    },

    recomendedJob: {
      type: Boolean,
      required: false,
      default: false
    },
    isSingleJob: {
      type: Boolean,
      required: false,
      default: false
    },

    isFavorite: Boolean,

    jobApplied: Boolean,
    jobDetails: {
      type: Object,
      required: true,
      default: () => {}
    },
    showRank: {
      type: Boolean,
      required: false,
      default: false
    },
    currentPage: {
      type: String,
      required: false,
      default: ''
    },
    WhatFieldText: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      isJobOpen: false,
      isMobile: true,
      cvBtnDisabled: false,
      ssaData: null
    };
  },
  mounted() {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    this.cvBtnDisabled = this.jobDetails.JobInfo.HasFilter;
  },

  computed: {
    ...mapGetters(['sendCvDate', 'isLogged']),

    ssa() {
      return get(this.$ssa, 'vm', {});
    },
    checkIfMandatory() {
      return this.jobDetails.JobInfo.HasFilter ? true : false;
    },

    sendingDate() {
      if (this.isLogged && this.jobApplied) {
        const sentDate = this.sendCvDate(this.jobDetails.Code)
          .substring(0, 10)
          .split('-')
          .reverse()
          .join('-');
        return sentDate;
      }
    },
    isEn() {
      return (
        this.jobDetails.JobInfo.Lang === 2 ||
        this.jobDetails.JobInfo.Lang === 'English'
      );
    }
  },

  methods: {
    sendSSA(eventName, jobcode, jobindex, ssasource) {
      this.ssa.log('LogSSA', {
        eventName: eventName,
        jobcode: jobcode,
        jobindex: jobindex,
        ssasource: ssasource
      });
    },

    checkRequirements(val) {
      this.cvBtnDisabled = val;
    },
    /**
     *    view job details only,  will send to update endpoint:
     *    @RowId , @JobCode ,@Action =1 for open new recomended job page , 0 for open job details slide
     */
    viewRecommended(rowId, jobCode, action) {
      const body = {
        RowId: rowId,
        JobCode: jobCode,
        Action: action
      };
      this.$axios.post(`${UPDATE_JOBS}`, body, {
        withCredentials: true
      });
    },

    triggerClose() {
      if (!this.isSingleJob) this.isJobOpen = false;
    },

    /**
     * @param {string} description
     */
    stripTags(description) {
      let count = 185;

      if (this.$vuetify.breakpoint.xsOnly) {
        count = 90;
      }

      if (DetectHTMLTagsPattern.test(description)) {
        description = description.replace(DetectHTMLTagsPattern, '  ');
      }
      if (description.length > count) {
        description = description.substring(0, count) + '...';
      }
      return description;
    },
    openSingleJob() {
      if (!this.isSingleJob) this.openJob();
    },
    // open job in new tab
    clickRecommendedJob() {
      if (this.recomendedJob) {
        const dataLayerJobClick = {
          category: 'recommender',
          action: 'job click',
          label: this.jobDetails.JobAnalytics.name, //job_name
          cd68: this.jobDetails.JobAnalytics.cd68, //IDjob
          cd69: this.jobDetails.JobAnalytics.cd69, //position
          cd70: this.currentPage,
          event: 'drushim_recommender',
          search: this.WhatFieldText
        };
        const dataLayerRecommenderClick = {
          category: 'recommender',
          action: 'recommender click',
          cd70: this.currentPage,
          event: 'drushim_recommender',
          search: this.WhatFieldText
        };
        gtm(dataLayerJobClick);
        gtm(dataLayerRecommenderClick);
      }
    },
    openJob() {
      this.sendSSA(
        'ListingView',
        this.jobDetails.JobInfo.JobCode,
        this.jobIndex,
        this.ssasource
      );

      if (this.recomendedJob) {
        gtm({
          category: 'recommender',
          action: 'recommender click',
          cd70: this.currentPage,
          event: 'drushim_recommender',
          search: this.WhatFieldText
        });
        const dataLayerJobClick = {
          category: 'recommender',
          action: 'job click',
          label: this.jobDetails.JobContent.Name, //job_name
          cd68: this.jobDetails.JobAnalytics.cd68, //IDjob
          cd69: this.jobDetails.JobAnalytics.cd69, //position
          cd70: this.currentPage,
          event: 'drushim_recommender',
          search: this.WhatFieldText
        };

        gtm(dataLayerJobClick);
      }

      /**
       * service event for statistics
       */
      // integrating isAA test

      this.$axios.get(
        `${STATISTICS_JOB_VIEW}/${this.jobDetails.JobInfo.JobCode}`,
        {
          withCredentials: true,
          params: {
            isAA: true
          }
        }
      );

      if (this.recomendedJob) {
        this.viewRecommended(
          this.jobDetails.RecommendedStatisticsRowId,
          this.jobDetails.JobInfo.JobCode,
          0
        );
      }
      /**
       * gtm data layers
       */
      const quickDetailDataLayer = {
        jobid: this.jobDetails.JobInfo.JobCode,
        event: 'quickdetail',
        ecommerce: {
          detail: {
            products: [
              pick(this.jobDetails.JobAnalytics, [
                'name',
                'id',
                'price',
                'brand',
                'category',
                'variant',
                'quantity'
                // 'coupon',
              ])
            ]
          }
        },
        'gtm.uniqueEventId': 638
      };
      const productClickDataLayer = {
        event: 'productClick',
        ecommerce: {
          currencyCode: 'ILS',
          click: {
            actionField: {
              list: get(this.jobDetails.JobAnalytics, 'list')
            },
            products: [
              pick(this.jobDetails.JobAnalytics, [
                'name',
                'id',
                'price',
                'brand',
                'category',
                'variant',
                'quantity'
                // 'coupon',
              ])
            ]
          }
        },
        'gtm.uniqueEventId': 544
      };

      /**
       * gtm fire EventS
       */
      gtm(quickDetailDataLayer);
      gtm(productClickDataLayer);
      this.isJobOpen = !this.isJobOpen;
    },
    closeJob() {
      this.isJobOpen = false;
    }
  }
};

export default JobHeader;
